import { __extends, __assign } from 'tslib';
import React__default, { Children, cloneElement } from 'react';
import { propTypes, defaultProps } from './Tabs.types.js';
import { Tab } from './Tab.component.js';
import styles from './Tabs.module.scss.js';

var Tabs = /** @class */ (function (_super) {
    __extends(Tabs, _super);
    function Tabs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tabs.prototype.componentDidMount = function () {
        var _a = this.props, borderless = _a.borderless, clustered = _a.clustered;
        if (borderless) {
            console.warn('DEPRECATION WARNING: The `borderless` prop is deprecated and support for it will be removed soon.');
        }
        if (clustered) {
            console.warn('DEPRECATION WARNING: The `clustered` prop is deprecated and support for it will be removed soon.');
        }
    };
    Tabs.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children, active = _a.active, onSelect = _a.onSelect, vertical = _a.vertical;
        // Children.map allows us to transform children before rendering them
        // more info here: https://reactjs.org/docs/react-api.html#reactchildrenmap
        var content = Children.map(children, function (child) {
            var name = child.props.name;
            var isActive = name === active;
            // cloneElement allows us to add additional props to an element
            // the additional props are merged with the element's original props
            // more info here: https://reactjs.org/docs/react-api.html#cloneelement
            return (React__default.createElement("div", { className: styles.Tab_wrapper },
                cloneElement(child, {
                    isActive: isActive,
                    onClick: function () { return onSelect(name); },
                }),
                React__default.createElement("span", { className: styles.Tab_divider + " " + (isActive ? styles.Tab_divider___active : '') + " " + (vertical
                        ? styles.Tab_divider___vertical
                        : '') })));
        });
        return (React__default.createElement("div", { className: styles.Tabs + " " + (className || '') + " " + (vertical ? styles.Tabs___vertical : '') }, content));
    };
    Tabs.propTypes = propTypes;
    Tabs.defaultProps = __assign({}, defaultProps);
    Tabs.Tab = Tab;
    Tabs.displayName = 'Tabs';
    return Tabs;
}(React__default.Component));

export { Tabs, Tabs as default };
